Ext.ns('mx.comp');

/**
 * Renders form fields (given in formFields[]) as a visual single row
 */
mx.comp.FormFieldsRow = Ext.extend(Ext.Panel, {
    layout: 'column',
    border: false,
    formFields: [],
    initComponent: function() {
        if (this.formFields.length > 0) {
            this.items = [];
            var panelConfig = {
                border: false,
                layout: 'mx-form',
                columnWidth: 1 / this.formFields.length,
                defaults: {
                    anchor: '100%',
                },
            };

            for (var i = 0; i < this.formFields.length; i++) {
                panelConfig.items = [this.formFields[i]];
                this.items.push(new Ext.Panel(panelConfig));
            }
        }

        mx.comp.FormFieldsRow.superclass.initComponent.call(this);
    },
});
